module.exports = __webpack_public_path__ + "img/silicium-vein.a0afec5b.png";